import React, { useState } from 'react';

interface PublishConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (comment: string) => void;
  draftChangesCount: number;
}

export const PublishConfirmModal: React.FC<PublishConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  draftChangesCount,
}) => {
  const [comment, setComment] = useState('');

  if (!isOpen) return null;

  return (
    <div className="cov-modal-overlay" onClick={onClose}>
      <div className="cov-modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="cov-modal-head">
          <h3 style={{ margin: 0, fontSize: '1.125rem' }}>Публикация версии каталога</h3>
          <button className="cov-btn cov-btn-outline" onClick={onClose}>✕</button>
        </div>

        <div className="cov-modal-body">
          <div style={{ background: '#131d31', padding: '1rem', borderRadius: '8px', border: '1px solid #1e293b' }}>
            <h4 style={{ margin: '0 0 0.5rem 0', fontSize: '0.875rem' }}>Сводка публикации</h4>
            <p style={{ margin: 0, fontSize: '0.8125rem', color: '#94a3b8' }}>
              Будет создана новая опубликованная версия <strong style={{ color: '#fff' }}>v(N+1)</strong>. Все изменения черновика ({draftChangesCount} изменений) станут активными для всех ролей и в форме «Создать заявку».
            </p>
          </div>

          <div className="cov-form-group">
            <label className="cov-form-label">Комментарий к релизу / Причина публикации</label>
            <textarea
              className="cov-form-textarea"
              rows={3}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Например: Обновление политики доступов и добавление вопросов для направления 10..."
            />
          </div>

          <div style={{ fontSize: '0.75rem', color: '#64748b' }}>
            ✓ Создаётся неизменяемая запись в журнале аудита.
            <br />
            ✓ Уже созданные и отправленные заявки остаются неизменными.
          </div>
        </div>

        <div className="cov-modal-foot">
          <button className="cov-btn cov-btn-outline" onClick={onClose}>Отмена</button>
          <button
            className="cov-btn cov-btn-primary"
            onClick={() => {
              onConfirm(comment);
              onClose();
            }}
          >
            Опубликовать сейчас
          </button>
        </div>
      </div>
    </div>
  );
};
